import { useCallback, useEffect, useState } from 'react';
import { useAuthProvider } from '../utils/auth';
import { OFFLINE_CHANGED, isSaved, offlineSupported, removeTrack, saveTrack } from '../utils/offlineLibrary';

// Whether a track is kept on this device for offline listening, and
// actions to save or remove it (see utils/offlineLibrary)
export const useOfflineTrack = (track) => {
  const { user } = useAuthProvider();
  const userId = user?.uuid;
  const [saved, setSaved] = useState(() => Boolean(track?.id && isSaved(track.id, userId)));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const refresh = () => setSaved(Boolean(track?.id && isSaved(track.id, userId)));
    refresh();
    window.addEventListener(OFFLINE_CHANGED, refresh);
    return () => window.removeEventListener(OFFLINE_CHANGED, refresh);
  }, [track?.id, userId]);

  const save = useCallback(async () => {
    setSaving(true);
    setError('');
    try {
      await saveTrack(track, userId);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }, [track, userId]);

  const remove = useCallback(() => removeTrack(track.id), [track]);

  return { supported: offlineSupported() && Boolean(userId), saved, saving, error, save, remove };
};
